import {useTranslation} from 'react-i18next'
import {Input} from '@/components/ui/input'

export const identityFields=['bone_structure','facial_features','marks','colors','texture','hair','clothing'] as const
export type VisualIdentity=Partial<Record<typeof identityFields[number],string>>

export function IdentityAnchorFields({value,onChange,disabled=false}:{value:VisualIdentity;onChange:(value:VisualIdentity)=>void;disabled?:boolean}) {
 const {t}=useTranslation()
 return <fieldset className="space-y-3" disabled={disabled}>
  <legend className="text-sm font-medium">{t('visualIdentity.title')}</legend>
  {identityFields.map(field=><label key={field} className="block space-y-1 text-sm">
   <span>{t(`visualIdentity.${field}`)}</span>
   <Input value={value[field] ?? ''} onChange={e=>onChange({...value,[field]:e.target.value})} />
  </label>)}
 </fieldset>
}
